import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { AppRoutes } from '../../routes';
import { AddLocation } from './AddLocation';
import { LocationProfileContainer } from './EditLocation/LocationProfileContainer';
import { ManageLocation } from './ManageLocation';

export const LocationManagement: React.FC = () => (
        <Switch>
        <Route exact path={AppRoutes.AddLocation} component={AddLocation} />
                <Route exact path={[AppRoutes.LocationProfile, AppRoutes.EditLocation]} component={LocationProfileContainer} />
        <Route path={AppRoutes.ManageLocation} component={ManageLocation} />
        </Switch>
);
